// 部门和员工选择器
// 只选择员工（只选择叶子节点）
// 只选择部门（只选择父节点）
// 部门和员工都可选
// 单选模式
// 多选模式
// dialog 模式
// trigger 模式
// 自定义请求url和参数

import OrgSelect from './src/index';

export default OrgSelect;
